import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageService } from './language.service';

export interface LanguageInterceptorConfig {
  allowFrFromBrowser: boolean;
}

export const LANGUAGE_INTERCEPTOR_CONFIG =
  new InjectionToken<LanguageInterceptorConfig>('LANGUAGE_INTERCEPTOR_CONFIG');

export const LANGUAGE_INTERCEPTOR_API_BASE_URL = new InjectionToken<string>(
  'LANGUAGE_INTERCEPTOR_API_BASE_URL'
);

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  private readonly languageService = inject(LanguageService);
  private readonly config = inject(LANGUAGE_INTERCEPTOR_CONFIG, { optional: true });
  private readonly apiBaseUrl = inject(LANGUAGE_INTERCEPTOR_API_BASE_URL);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!request.url.startsWith(this.apiBaseUrl)) {
      return next.handle(request);
    }

    const language = this.languageService.getLanguageForRequest(
      this.config?.allowFrFromBrowser ?? false
    );
    return next.handle(
      request.clone({
        setHeaders: { 'X-Language': language },
      })
    );
  }
}
